<template>
  <div>
    <TopBar :range="range"/>
    <div id="main" class="skybackground pt-0 pb-0">
      <!--      Conform Box-->
      <vue-confirm-dialog></vue-confirm-dialog>

      <!--      Modal appear on start of create report -->
      <create-report-modal/>
      <!--    Filter Tab-->
      <construction-filter-bar :searchString="searchstring"/>

      <div class="row justify-content-center">

        <a id='dwnldLnk' download='construction report.pdf' style="display:none;"/>

        <div class="col-md-6 pr-0 pl-1" id="doctable">
          <div class="doctable">
            <div class="tableFixHead cscroll" :class="{selectionactive : selectedRecords.length}">
              <div class="search-bar pt-2 pb-1 col-md-12">
                <div class="float-left mt-1">
                  <button @click="getAllReports" type="button" data-toggle="modal" data-target="#bautagemodal" :disabled="!usercan('editor')">
                    <img class="plus-img" src="@/assets/images/plus.png" alt="image">
                  </button> {{$t('create_construction_diary')}}
                </div>
                <div class="float-right">
                  <div class="form-group doc-search">
                    <input type="text" v-model="searchstring" class="form-control" placeholder="Suche">
                    <img class="form-control-feedback search-img" src="@/assets/images/search.png" alt="img">
                  </div>
                </div>
              </div>
              <table class="table table-hover table-fixed cd-tables position-relative">
                <thead>
                <tr>
                  <th class="text-center pl-2">
                    <input type="checkbox" class="master-checkbox" v-model="masterCheckbox">
                  </th>
                  <th class="pl-3">PDF</th>
                  <th>
                    Bericht
                  </th>
                  <th> {{$t('date')}}
                    <div  v-if="crDateSort" class="sort float-right" @click="sortData('crdate','ASC')">
                      <img src="@/assets/images/sort-down-green.png" alt="arrow">
                      <img src="@/assets/images/sort-up-green.png" alt="arrow">
                    </div>
                    <div v-else class="sort float-right" @click="sortData('crdate','DESC')">
                      <img src="@/assets/images/sort-down.png" alt="icon">
                      <img src="@/assets/images/sort-up.png" alt="icon">
                    </div>
                  </th>
                  <th>Nr</th>
                  <th>Rev</th>
                  <th>Berichtersteller </th>
                  <th>
                    {{$t("created_on")}}
                    <div  v-if="createdSort" class="sort float-right" @click="sortData('created','ASC')">
                      <img src="@/assets/images/sort-down-green.png" alt="arrow">
                      <img src="@/assets/images/sort-up-green.png" alt="arrow">
                    </div>
                    <div v-else class="sort float-right" @click="sortData('created','DESC')">
                      <img src="@/assets/images/sort-down.png" alt="icon">
                      <img src="@/assets/images/sort-up.png" alt="icon">
                    </div>
                  </th>
                  <th> Freigabe </th>
                  <th class="text-center">Status
                    <div  v-if="statusSort" class="sort float-right" @click="sortData('status','ASC')">
                      <img src="@/assets/images/sort-down-green.png" alt="arrow">
                      <img src="@/assets/images/sort-up-green.png" alt="arrow">
                    </div>
                    <div v-else class="sort float-right" @click="sortData('status','DESC')">
                      <img src="@/assets/images/sort-down.png" alt="icon">
                      <img src="@/assets/images/sort-up.png" alt="icon">
                    </div>
                  </th>
                  <th></th>
                  <th></th>
                </tr>
                </thead>
                <tbody  v-if="constructionReports.length">

                <tr v-for="(doc , index) in constructionReports"  class="photo-tr" :class="{'active-tr': selectedReport.constructionreportid === doc.constructionreportid }" v-bind:key="index"  @click="setSelectedReport(doc,$event); selectedIndex = doc.constructionreportid">
                  <!--                  <td class="pl-lg-3">-->
                  <!--                    <input type="checkbox" class="custom-checkbox" aria-label="Checkbox for following text input">-->
                  <!--                  </td>-->
                  <td class="text-center pl-2" data-value="btn">
                    <input type="checkbox" aria-label="Checkbox for following text input" :value="doc.constructionreportid" v-model="selectedRecords" data-value="btn">
                  </td>
                  <td class="pl-3">
                    <img src="@/assets/images/pdf-icon.png" class="icon pr-2" data-value="btn" title="Öffnen im Browser" @click="downloadPdf(doc,false)" alt="icon" >
                    <img src="@/assets/images/download-icon.png" @click="downloadPdf(doc,true)" class="icon" data-value="btn" alt="icon" title="PDF herunderladen">
                  </td>
                  <td>
                    <template v-if="doc.reporttype == 'W'">
                      Wochenbericht
                    </template>
                    <template v-else-if="doc.reporttype == 'D'">
                      Tagesbericht
                    </template>
                    <template v-else>
                      Tagesbericht
                    </template>
                  </td>
                  <td>{{doc.crdate | setDate}}</td>
                  <td>{{doc.runid}}</td>
                  <td>{{doc.revision}}</td>
                  <td>{{doc.creator}}</td>
                  <td>{{doc.created | setDate}} <h3></h3></td>
                  <td class="text-center">
                    <div class="custom-checkbox text-center icon" data-value="btn" v-if="usercan('editor')">
                      <input type="checkbox"  class="custom-control-input" v-model="doc.locked" :id="'customCheck'+index" @change="updateConstructionReportStatus(doc)">
                      <label v-if="doc.locked" class="position-relative"><i class="fa fa-lock lock-icon position-absolute" style="font-size: 17px"></i></label>
                      <label v-else class="custom-control-label"  :for="'customCheck'+index"></label>
                    </div>
                  </td>
                  <td class="text-center">
                    <i class="fa-solid fa-circle font1rem text-success pl-1" v-if="doc.status === '1' || doc.status === 1"></i>
                    <i class="fa-solid fa-circle font1rem text-danger pl-1" v-if="doc.status === '0' || doc.status === 0"></i>
                  </td>
                  <td class="text-center">
                    <i :class="(doc.reportparams.attached_photos && doc.reportparams.attached_photos.length > 0) ? 'text-primary' : 'grey-text'" class="fas fa-image font1rem" aria-hidden="true" style="width: 21px"></i>
                  </td>
                  <td class="pl-0 pr-0" style="min-width:22px;">
                    <template v-if="usercan('editor')">
                      <img src="@/assets/images/delete_icon.png" v-if="!doc.locked" data-value="btn" alt="remove" class="c-d-delete-icon" width="21" @click="deleteDocument(doc.constructionreportid)" title="Löschen">
                    </template>
                  </td>
                </tr>

                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="10" class="text-center">
                    <h3 class="mt-4 ml-2"> Kein Bautagebuch vorhanden</h3>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>




          <div v-if="selectedRecords.length" class="shadow btns-bar border-top border-dark docs-pagination col-md-12 bg-white text-center position-absolute">
            <div class="pt-1 p1-0">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4 text-left pl-0 pr-1">
                    Ausgewählte Fotodokumentationen : <strong> {{selectedRecords.length}} </strong>
                  </div>
                  <div class="col-md-8 text-right">
                    <button class="btn btn-light shadow-lg font1rem mb-1" @click="masterCheckbox = true">
                      Alle auswählen
                    </button>
                    <button class="btn btn-light font1rem shadow-lg mb-1" @click="masterCheckbox = false">
                      Auswahl aufheben
                    </button>
<!--                    <button class="btn btn-light font1rem shadow-lg mb-1" @click="makeTicket">-->
<!--                      Ticket erstellen-->
<!--                    </button>-->
                    <button class="btn btn-light font1rem shadow-lg mb-1 ml-2" type="button" @click="startdownload()">
                      Als ZIP Archiv speichern
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="border-top border-dark  docs-pagination col-md-12 bg-white text-center">
            <div class="pt-1 pb-0" v-if="constructionReports.length">
              <div class="position-absolute items-count-bar">
                <span class="font-weight-normal" v-if="meta.maxcount > 20"> {{currentPage === 1 ? '1' : ((currentPage - 1) * 20)}} bis {{currentPage * 20}} von  {{meta.maxcount}} Bautagesberichten</span>
                <span class="font-weight-normal" v-else> 1 bis {{ meta.maxcount }} von  {{meta.maxcount}} Bautagesberichten</span>
              </div>
              <sliding-pagination
                :current="currentPage"
                :total="Math.ceil(meta.maxcount / 20)"
                @page-change="pageChangeHandler"/>
            </div>
          </div>
        </div>
        <preview v-if="constructionReports.length > 0"/>
      </div>
    </div>
  </div>
</template>
<script>

import SideNav from './SideBar/ConstructionDiarySideTabsLinks'
import Preview from './ConstructionDiaryPreview'
import ConstructionFilterBar from './SideBar/ConstructionFilterBar'
import {mapState} from 'vuex'
import SlidingPagination from 'vue-sliding-pagination'
import {formatDate} from '../../common'
import CreateReportModal from './CreateReportModal'
import TopBar from './ConstructionDiaryTopBar'
import axios from 'axios'
import moment from 'moment'
export default {
  components: {
    TopBar,
    CreateReportModal,
    SideNav,
    SlidingPagination,
    Preview,
    ConstructionFilterBar
  },
  data () {
    return {
      selectedRecords: [],
      searchstring: '',
      currentPage: 1,
      index: 0,
      pdf: null,
      crDateSort: false,
      createdSort: false,
      statusSort: false,
      masterCheckbox: false,
      selectedIndex: null,
      range: [1 , 300],
      orderQry: [
        {
          _explicitType :"com\\projectdocu\\OrderSettingVO",
          fieldname: "runid",
          order: "DESC"
        }
      ]
    }
  },
  created () {
    this.getAllConstructionReports();
  },

  filters: {
    setDate: (date) => formatDate(date)
  },
  methods: {

    makeTicket() {
      this.$store.state.tickets.selectedRecords = this.selectedRecords
      this.$store.state.tickets.createmode = true
      this.$router.push({name: 'Tickets', params: {id: this.$route.params.id}})
    },

    startdownload() {
      let projectId = this.$route.params.id
      console.log('Download starten', this.selectedRecords)

      var params = {
        "serviceName": "ProjectdocuService",
        "methodName": "getCReportsAsZIP",
        "parameters": [
          this.selectedRecords
        ]
      }

      // await axios.post(this.getImagesUrl, paramsOld, {
      axios.post(process.env.VUE_APP_BASE_AMF_URL + `getCReportsAsZIP&type=s&token=` + localStorage.sessiontoken, params, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json',
        },
        responseType: 'blob' // Need to serv correct file
      })
        .then(response => {
          console.log('Response', response)

          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'Bautagebuch Sammlung.zip');
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })
    },

    async sortData(qry , order = "ASC"){
      const sort =  [{
        _explicitType :"com\\projectdocu\\OrderSettingVO",
        fieldname: qry,
        order: order
      }]
      const param = { params: [ this.$route.params.id, 20, (this.currentPage - 1), null, sort ], is_paging: true }
      await this.$store.dispatch('getConstructionReports', param);
      this.crDateSort = order === "DESC" && qry  === 'crdate'
      this.createdSort = order === "DESC" && qry  === 'created'
      this.statusSort = order === "DESC" && qry  === 'status'
    },

    async getAllConstructionReports(){
      await this.$store.dispatch('getConstructionReports', this.getReportsParams());
      this.$store.dispatch('getConstructionWeeklyReports', { params: [this.$route.params.id] });
      const dif_from = moment(this.meta.minimumDate , 'DD.MM.YYYY');
      const dif_to = moment(this.meta.maximumDate , 'DD.MM.YYYY');
      this.$store.commit('setConstructionMetaDateFrom',this.meta.minimumDate)
      this.$store.commit('setConstructionMetaDateTo',this.meta.maximumDate)
      let dif = moment.duration(dif_to.diff(dif_from)).asDays();
      this.range = [0 , dif];
      const my_range = $("#rangeSliderInConstructionDocs").data("ionRangeSlider");
      // update range data after get reports
      if (my_range){
        setTimeout(function (){
          my_range.update({min: 0, max: dif, to: dif, from: 0});
          //refresh datepicker after set the values
          const{ 0: from,1: to } = [$("#from"),$("#to")]
          to.datepicker("setDate", to.val());
          from.datepicker("setDate", from.val());
          to.datepicker('refresh');
          from.datepicker('refresh');
          my_range.reset();
        });
      }
      const doc = this.constructionReports[0]
      if (doc && this.$route.name !== 'ConstructionReportPreview') {
        await this.$router.push({ name: 'ConstructionReportPreview', params: { id: doc.projectid.toString(), reportId: doc.constructionreportid.toString() }})
      }
    },

    //Method foe delete document
    async deleteDocument(id){
      this.$confirm({
        message: "Bautagebuch löschen?",
        button: {
          no: 'Abbrechen',
          yes: 'Ja'
        }, callback: confirm => {
          if (confirm) {
            this.deleteDoc(id);
          }
        }
      });
    },

    async deleteDoc(id){
      await this.$store.dispatch('deleteConstructionReport',id);
      await this.$store.dispatch('getConstructionReports', this.getReportsParams())
      if (this.$route.name === 'ConstructionReportPreview'){

        if(this.pageReports.length > 0) {
          let firstitemid = this.pageReports[0].constructionreportid
          await this.$router.push( { name: 'ConstructionReportPreview', params: {id: this.$route.params.id, reportId: firstitemid } } );
        } else {
          await this.$router.push( { name: 'constructionDocs', params: { id: this.$route.params.id }} );
        }

      }
    },



    // filter docs list by date
    async filterReportsByDate () {
      this.currentPage = 1;
      let dateFrom = moment(this.dateRangeFrom, 'DD.MM.YYYY').format('YYYY-MM-DD')
      let dateTo = moment(this.dateRangeTo, 'DD.MM.YYYY').format('YYYY-MM-DD')

      let filters = {
        _explicitType: 'com\\projectdocu\\PredicateOperatorAndVO',
        operands: []
      }
      // eslint-disable-next-line camelcase
      let date_filter = {
        fieldname: 'crdate',
        fieldvalueFrom: dateFrom+' 00:00:00',
        fieldvalueTo: dateTo +' 23:59:59',
        _explicitType: 'com\\projectdocu\\PredicateOperandBetweenVO'
      }
      filters.operands.push(date_filter);
      let searchQry =  {
        _explicitType :"com\\projectdocu\\PredicateOperandLikeVO",
        fieldname :"runid",fieldvalue: `${this.searchstring}`
      }

      if (searchQry.length){
        filters.operands.push(searchQry);
      }

      let payload = { params: [ this.$route.params.id, 50, 0, filters , this.orderQry ], is_paging: true }
      await this.$store.dispatch('getConstructionReports', payload)
    },

    setSelectedReport (doc, event) {
      if (event.target.getAttribute('data-value') !== 'btn' && event.target.tagName !== 'INPUT' && event.target.tagName !== 'LABEL') {
        this.$store.commit('setSelectedReport', doc)
        if (doc.constructionreportid !== this.$route.params.reportId) {
          // eslint-disable-next-line standard/object-curly-even-spacing
          this.$router.push({ name: 'ConstructionReportPreview', params: { id: doc.projectid.toString(), reportId: doc.constructionreportid.toString() }})
        }
      }
    },

    // params for construction report with params
    getReportsParams () {
      return { params: [ this.$route.params.id, 20, (this.currentPage - 1), null, this.orderQry ], is_paging: true }
    },

    pageChangeHandler (activePage) {
      this.currentPage = activePage
      this.$store.dispatch('getConstructionReports', this.getReportsParams());
    },

    showDetailsTag () {
      this.$store.commit('toggleDetailsTab', true)
      this.$store.commit('toggleMainDetailsTab', false)
    },


    // For create new report get all reports ( All Reports without pages )
    getAllReports () {
      let payload = {params: [ this.$route.params.id, null, null, null, this.orderQry ], is_paging: false}
      let payload_w = {params: [ this.$route.params.id], is_paging: false}
      this.$store.dispatch('getConstructionReports', payload)
      this.$store.dispatch('getConstructionWeeklyReports', payload_w)
    },


    async  downloadPdf (doc, isDownload) {
      let id = doc.constructionreportid
      let _this = this
      _this.$store.commit('loading', true)
      let url = `${process.env.VUE_APP_GET_METHOD_URL}creport&crid=${id}&token=${localStorage.sessiontoken}`
      await fetch(url, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid
        }
      }).then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            let pdf = reader.result
            if (isDownload) {
              let dlnk = document.getElementById('dwnldLnk')
              dlnk.download = `${moment(doc.crdate).format('YYYY-MM-DD')}_Bautagesbericht_${doc.runid}_${doc.revision}.pdf`
              dlnk.href = pdf
              dlnk.click()
            } else {
              let html = `<iframe width='100%' height='100%' src='${pdf}'></iframe>`
              let newTab = window.open('Construction-Report-PDF?printerFriendly=true', '_blank')
              newTab.document.write(html)
            }
            _this.$store.commit('loading', false)
          }
        })
    },


    /** Update Construction Report On Checkbox Change
     *
     * @returns {Promise<void>}
     */
    async updateConstructionReportStatus(doc) {
      this.$confirm({
        message: "Wenn der Bericht freigegeben wird, kann er nicht mehr geändert werden. Es wird eine neue Revision erstellt. Bericht freigeben?",
        button: {
          no: 'Abbrechen',
          yes: 'Ja'
        }, callback: confirm => {
          if (confirm) {
            this.updateStatus(doc);
          }else {
            doc.locked = false
          }
        }
      })
    },


    async updateStatus (doc) {
      this.$store.commit('loading', true)
      let payload = {id: doc.constructionreportid, isEdit: false}
      await this.$store.dispatch('getConstructionReportById', payload )
      // eslint-disable-next-line camelcase
      let cons_report = doc
      let group = this.report.groups
      let weather = this.report.weather
      let staff = this.report.staff
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          'methodName': 'updateConstructionReport',
          'parameters': [cons_report, weather, group, staff],
          'serviceName': 'ProjectdocuService'
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        if (res.status === 200 || res.statusText === 'OK') {
          this.$store.commit('loading', false)
          this.$toast.success('Bautagesbericht freigegeben')
        }
      }).catch(error => {
        this.$store.commit('loading', false)
        this.$toast.success('Oops Something Went Wrong ....!')
      })
    },


  },

  computed: {
    ...mapState({
      activeOverView: state => state.constructionDiary.activeOverView,
      selectedReport: state => state.constructionDiary.selectedReport,
      meta: state => state.constructionDiary.reportsMeta,
      dateRangeFrom: state => state.photoDocumentation.dateRangeFrom,
      dateRangeTo: state => state.photoDocumentation.dateRangeTo,
      report: state => state.constructionDiary.reportDetailsCopy,
      report_id: state => state.constructionDiary.selectedReport.constructionreportID,
      constructionReports: state => state.constructionDiary.constructionReports
    }),


    pageReports () {
      if (this.constructionReports.length > 0) {
        let _this = this
        return this.constructionReports.slice(_this.index, _this.index + 10)
      }
    }
  },

  watch: {
    'dateRangeFrom': function () {
      this.filterReportsByDate()
    },
    'dateRangeTo': function () {
      this.filterReportsByDate()
    },
    masterCheckbox: function (val){
      if (val){
        this.constructionReports.forEach(item => {
          if (!this.selectedRecords.includes(item.constructionreportid)){
            this.selectedRecords.push(item.constructionreportid)
          }
        })
      }else if (val === false){
        this.selectedRecords = []
      }
    },
  }

}
</script>

<style scoped>
.grey-text {
  color: #a0a0a0;
}
.active-tr{
  background: lightgray;
}
table tr:hover{
  background: lightgray;
  cursor: pointer;
}
.doctable th, .doctable td {
  white-space: nowrap;
}
.doctable th{
  font-size: 13px;
}
td .icon:hover{
  cursor: pointer;
}
.custom-control-label::before{
  top: 2px;
}
.custom-control-label::after{
  top: 4px;
}
.custom-control.custom-checkbox.icon{
  margin-bottom: 0 !important;
}
.c-d-delete-icon{
  z-index: 1000;
  display: none;
}
table tr:hover td .c-d-delete-icon{
  display: block;
}
table tr.photo-tr:hover td .c-d-delete-icon{
  display: block;
}
.photo-tr:hover td .c-d-delete-icon{
  display: block;
}
table tr:hover td .fa-picture-o{
  display: none;
}
.sort.float-right{
  padding: 0px 4px 0px 6px;
}
.lock-icon{
  font-size: 17px;
  top: -6px;
  left: -1.7rem;
}
.btns-bar.position-absolute{
  bottom: 40px;
}

#doctable {
  overflow: hidden;
}
.selectionactive {
  padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/ConstructionDiaryListPage.vue